import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { FormRulesTabPanel } from "@/features/form-editor/components/form-rules-tab-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/full/form/rules",
)({
	component: FormRulesTabPanel,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; jobTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				jobTypeId: z.string().parse(p.jobTypeId),
			};
		},
	},
});
